package com.eladfinish.bible.contest.appcontent

object HebrewMarks {
    /** A regex character class of the nikud (vowel) marks. */
    const val NIKUD_CHARS = "[" + "ְֱֲֳִֵֶַָׇֹֻּׁׂ" + "]"
}

/** The text without nikud, e.g. for sorting Hebrew words the way the app does. */
fun String.withoutNikud(): String = replace(HebrewMarks.NIKUD_CHARS.toRegex(), "")
